
import Vue from "vue";

interface Manuscript {
  id: string;
  title: string;
  characterCount: number;
  novelId: string;
}

export default Vue.extend({
  name: "ManuscriptListItem",
  props: {
    manuscript: {
      type: Object as () => Manuscript,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    selectionOrder: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(): void {
      if (!this.isDisabled) {
        this.$emit("manuscript-click", this.manuscript);
      }
    },
    formatCharacterCount(count: number): string {
      return count.toLocaleString("ja-JP");
    },
  },
});
